import { Injectable } from '@angular/core';
import { ApiService } from '@shared/services';
import { Observable, catchError, map, of, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { LearningAttachment } from '@shared/entities/learningAttachment';
import { environment } from '@environments/environment';

const LOG_PREFIX = '[Api][LearningAttachmentForm] ';

@Injectable({
  providedIn: 'root'
})
export class LearningAttachmentService extends ApiService<any> {
  constructor(private http: HttpClient) {
    const masterUrl = '/learning-attachments';
    const detailUrl = '/learning-attachments';
    super(LearningAttachment, masterUrl, detailUrl, undefined, 'learning-form');
  }

  getAttachment(learningId: string, mediaType?: 'video' | 'image' | 'document'): Observable<LearningAttachment[]> {
    const params: any = { learningId: learningId };
    if (mediaType) {
      params.mediaType = mediaType;
    }

    return this.http
      .get<{ attachments: any[] }>(`${environment.apiBaseUrl}/learning-attachments`, {
        params: params
      })
      .pipe(
        map((response) => {
          this.logger.debug(LOG_PREFIX + 'getAttachment raw response:', response);
          return (response.attachments || []) as LearningAttachment[];
        }),
        tap((result) => {
          this.logger.debug(LOG_PREFIX + 'getAttachment success', result);
        }),
        catchError((error) => {
          this.logger.error(LOG_PREFIX + 'getAttachment error', error);
          return of([]);
        })
      );
  }

  /**
   * @deprecated Non più necessario. Gli attachment vengono ora gestiti
   * automaticamente tramite i campi videoPaths/imagePaths/documentPaths
   * nelle chiamate POST/PUT di Learning. La rimozione avviene automaticamente
   * quando si aggiorna un Learning con una lista che non include più certi path.
   */
  uploadAttachment(learningId: string, file: File): Observable<LearningAttachment[]> {
    const formData = new FormData();
    formData.append('request', JSON.stringify({ learningId: learningId }));
    formData.append('file', file, file.name);

    return this.http
      .post<{ attachments: any[] }>(`${environment.apiBaseUrl}/learning-attachments/add`, formData)
      .pipe(
        map((response) => {
          this.logger.debug(LOG_PREFIX + 'uploadAttachment raw response:', response);
          return (response.attachments || []) as LearningAttachment[];
        }),
        tap((result) => {
          this.logger.debug(LOG_PREFIX + 'uploadAttachment success', result);
        }),
        catchError((error) => {
          this.logger.error(LOG_PREFIX + 'uploadAttachment error', error);
          throw error;
        })
      );
  }

  deleteAttachment(learningId: string, attachmentId: string): Observable<LearningAttachment[]> {
    return this.http
      .delete<{ attachments: any[] }>(`${environment.apiBaseUrl}/learning-attachments/remove`, {
        body: {
          learningId: learningId,
          attachmentId: attachmentId
        }
      })
      .pipe(
        map((response) => {
          this.logger.debug(LOG_PREFIX + 'deleteAttachment raw response:', response);
          return (response.attachments || []) as LearningAttachment[];
        }),
        tap((result) => {
          this.logger.debug(LOG_PREFIX + 'deleteAttachment success', result);
        }),
        catchError((error) => {
          this.logger.error(LOG_PREFIX + 'deleteAttachment error', error);
          throw error;
        })
      );
  }
}
